"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchForm = void 0;
const dom_utils_1 = require("../../utils/dom-utils");
const switchForm = (id) => {
    const element = (0, dom_utils_1.elementId)(id);
    if (element.classList.contains('animate-fadeIn')) {
        element.classList.remove('animate-fadeIn');
        element.classList.add('animate-fadeOut');
    }
    else {
        element.classList.remove('animate-fadeOut');
        element.classList.add('animate-fadeIn');
    }
};
exports.switchForm = switchForm;
